import React from 'react';
import { AlertCircle } from 'lucide-react';

interface RecordFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: 'text' | 'number' | 'select';
  placeholder?: string;
  options?: string[];
  required?: boolean;
  min?: string;
  max?: string;
}

const RecordField: React.FC<RecordFieldProps> = ({
  label,
  value,
  onChange,
  error,
  type = 'text',
  placeholder,
  options = [],
  required = false,
  min,
  max,
}) => {
  const baseClasses = `w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white ${
    error ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'
  }`;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      {type === 'select' ? (
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={baseClasses}
        >
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={baseClasses}
          placeholder={placeholder}
          min={min}
          max={max}
        />
      )}
      
      {error && (
        <p className="mt-1 text-sm text-red-500 flex items-center">
          <AlertCircle className="w-3 h-3 mr-1" />
          {error}
        </p>
      )}
    </div>
  );
};

export default RecordField;